import Axios from "axios";
import header from "./auth/header";

const API_URL_V3 = process.env.API_URL + "/api/v3";

class Whistleblowing {
    store(data) {
        return Axios.post(API_URL_V3 + "/whistleblowing-service/add-report/", data);
    }
}

export default new Whistleblowing();



// WEBPACK FOOTER //
// ./src/api/whistleblowing.js